import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DownloadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"download"}/>
}
